module.exports = __webpack_public_path__ + "img/Oiltanking_South-America_Argentina_Brandsen_Tanks_2010-01-15_02.d4e14c61.jpg";